import $ from 'jquery';
import config from './../../config';
const URL_API = config.urlApi+'controlador/inventario_productos/searchProductoUnidadByUnidad.php';

export default function searchProductoUnidadByUnidad({values}){
    return $.ajax({
        url: URL_API,
        type: 'POST',
        data: values
    })
}